import "./assets/styles/custom.css";

import Vue from "vue";
import "./plugins/axios";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store";
import ResponseHelper from "./utils/ResponseHelper";
import LoadingProgress from "./components/LoadingProgress";

Vue.config.productionTip = false;

// noinspection JSUnusedGlobalSymbols
Vue.prototype.$response = new ResponseHelper();
Vue.component("loading-progress", LoadingProgress);

// noinspection JSUnusedGlobalSymbols
new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
